import { useMemo } from "react";
import { useSelector } from "react-redux";

import useMaxCanvasSize from "./useMaxCanvasSize";

function useIsExportSizeTooBig() {
  const map = useSelector((state) => {
    return state.map.olMap;
  });
  const exportSize = useSelector((state) => {
    return state.app.exportSize;
  });
  const exportLayout = useSelector((state) => {
    return state.app.exportLayout;
  });
  const exportScale = useSelector((state) => {
    return state.app.exportScale;
  });
  const maxCanvasSize = useMaxCanvasSize();
  const size = useMemo(() => {
    return exportSize || map?.getSize();
  }, [exportSize, map]);

  // If the current layout is a PDF layout, there is no limit of size.
  const isExportSizeTooBig = useMemo(() => {
    return (
      (!exportLayout?.properties?.mapWidth &&
        maxCanvasSize &&
        size &&
        (maxCanvasSize < size[0] * exportScale ||
          maxCanvasSize < size[1] * exportScale)) ||
      false
    );
  }, [exportLayout, maxCanvasSize, size, exportScale]);

  return isExportSizeTooBig;
}

export default useIsExportSizeTooBig;
